import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className='bg-black py-4 text-white text-center'>
            <div className="container">
                <div className="row">
                    <div className="col">
                       <Link className="text-decoration-none text-white fw-bolder" to="/">Home</Link> | 
                       <Link className="text-decoration-none text-white fw-bolder" to="/courses"> Courses</Link> | 
                       <Link className="text-decoration-none text-white fw-bolder" to="/blog"> Blog</Link> | 
                       <Link className="text-decoration-none text-white fw-bolder" to="/FAQ"> FAQ</Link> | 
                       <Link className="text-decoration-none text-white fw-bolder" to="/login"> Login</Link> | 
                       <Link className="text-decoration-none text-white fw-bolder" to="/register"> Register</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;